// extracted by mini-css-extract-plugin
module.exports = {"linkActive":"legal_linkActive__JZWsy"};